'use client';

import { c as _c } from "react/compiler-runtime";
import { type KeyboardEvent, useEffect } from 'react';
import { PurchaseButton } from '../product-details';
import { MiniPdpDisclaimers } from './mini-pdp-disclaimers';
import { MiniPdpFulfillment } from './mini-pdp-fulfillment';
import { MiniPdpQuantity } from './mini-pdp-quantity';
import { MiniPdpVariants } from './mini-pdp-variants';
import { type UseMiniPdpAddToCartProps, useMiniPdpAddToCart } from './model/use-mini-pdp-add-to-cart';
import { useMiniPdpBopis } from './model/use-mini-pdp-bopis';
import type { MiniPdpFulfillmentProps } from './model/use-mini-pdp-fulfillment';
import type { MiniPdpVariantsProps } from './model/use-mini-pdp-variants';
type MiniPdpPurchaseFormProps = UseMiniPdpAddToCartProps & MiniPdpVariantsProps & Pick<MiniPdpFulfillmentProps, 'onOpenSddAddress' | 'onOpenStoreDrawer'> & {
  onErrorChange?: (isError: boolean) => void;
};
const preventImplicitSubmit = (event: KeyboardEvent<HTMLFormElement>) => {
  if (event.key === 'Enter' && !(event.target instanceof HTMLButtonElement)) {
    event.preventDefault();
  }
};
export function MiniPdpPurchaseForm(t0) {
  const $ = _c(30);
  const {
    base,
    product,
    tailored,
    isLoading,
    isError: t1,
    onErrorChange,
    onOpenSddAddress,
    onOpenStoreDrawer
  } = t0;
  const isError = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== base || $[1] !== isError || $[2] !== isLoading || $[3] !== product || $[4] !== tailored) {
    t2 = {
      base,
      product,
      tailored,
      isLoading,
      isError
    };
    $[0] = base;
    $[1] = isError;
    $[2] = isLoading;
    $[3] = product;
    $[4] = tailored;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    disabled,
    isError: isAddToCartError,
    isSubmitting,
    isSuccess,
    submitHandler
  } = useMiniPdpAddToCart(t2);
  let t3;
  if ($[6] !== isError || $[7] !== isLoading || $[8] !== product || $[9] !== tailored) {
    t3 = {
      product,
      tailored,
      isLoading,
      isError
    };
    $[6] = isError;
    $[7] = isLoading;
    $[8] = product;
    $[9] = tailored;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const {
    shouldRenderNearbyStoresCTA
  } = useMiniPdpBopis(t3);
  let t4;
  let t5;
  if ($[11] !== isAddToCartError || $[12] !== onErrorChange) {
    t4 = () => {
      onErrorChange?.(isAddToCartError);
      return () => onErrorChange?.(false);
    };
    t5 = [isAddToCartError, onErrorChange];
    $[11] = isAddToCartError;
    $[12] = onErrorChange;
    $[13] = t4;
    $[14] = t5;
  } else {
    t4 = $[13];
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  if ($[15] !== base || $[16] !== disabled || $[17] !== isError || $[18] !== isLoading || $[19] !== isSubmitting || $[20] !== isSuccess || $[21] !== onOpenSddAddress || $[22] !== onOpenStoreDrawer || $[23] !== product || $[24] !== shouldRenderNearbyStoresCTA || $[25] !== tailored) {
    t6 = product && <><MiniPdpVariants base={base} tailored={tailored} /><div className="mini-pdp-drawer__purchase"><MiniPdpFulfillment product={product} tailored={tailored} isLoading={isLoading} isError={isError} onOpenSddAddress={onOpenSddAddress} onOpenStoreDrawer={onOpenStoreDrawer} /><MiniPdpDisclaimers product={product} tailored={tailored} />{shouldRenderNearbyStoresCTA ? <div className="mini-pdp-drawer__purchase-row"><PurchaseButton type="button" text="Show in-stock stores" testId="mini-pdp-show-in-stock-stores" onClick={onOpenStoreDrawer} /></div> : <div className="mini-pdp-drawer__purchase-row"><MiniPdpQuantity product={product} tailored={tailored} isLoading={isLoading} isError={isError} /><PurchaseButton text={isSuccess ? "Added to cart" : "Add to cart"} disabled={disabled} loading={isSubmitting} isSuccess={isSuccess} formId="mini-pdp-form" testId="mini-pdp-add-to-cart" /></div>}</div></>;
    $[15] = base;
    $[16] = disabled;
    $[17] = isError;
    $[18] = isLoading;
    $[19] = isSubmitting;
    $[20] = isSuccess;
    $[21] = onOpenSddAddress;
    $[22] = onOpenStoreDrawer;
    $[23] = product;
    $[24] = shouldRenderNearbyStoresCTA;
    $[25] = tailored;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== submitHandler || $[28] !== t6) {
    t7 = <form id="mini-pdp-form" data-testid="mini-pdp-form" className="mini-pdp-drawer__form" onKeyDown={preventImplicitSubmit} onSubmit={submitHandler}>{t6}</form>;
    $[27] = submitHandler;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
}